/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.20/esri/copyright.txt for details.
*/
import{VTLMaterial as t}from"./VTLMaterial.js";class r extends t{constructor(t){super(t)}geometryInfo(){return r.GEOMETRY_LAYOUT}opacityInfo(){return null}attributes(){return r.ATTRIBUTES}attributesInfo(){return r.ATTRIBUTES_INFO}}r.ATTRIBUTES=[],r.GEOMETRY_LAYOUT=[{name:"a_pos",count:2,type:5120,offset:0,stride:2,normalized:!1,divisor:0}],r.ATTRIBUTES_INFO={};export{r as VTLBackgroundMaterial};
